import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'payAppsClient';

// PAGINATION
export const paginationPayAppsClients = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllPayAppsClients = async filters => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createPayAppsClient = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updatePayAppsClient = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deletePayAppsClient = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationPayAppsClients.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllPayAppsClients.propTypes = {
  filters: PropTypes.object.isRequired,
};

createPayAppsClient.propTypes = {
  values: PropTypes.object.isRequired,
};

updatePayAppsClient.propTypes = {
  values: PropTypes.object.isRequired,
};

deletePayAppsClient.propTypes = {
  id: PropTypes.string.isRequired,
};
